import { FC, useEffect, useState } from 'react'
import {
	Button,
	Card,
	Flex,
	List,
	Typography,
	Descriptions
} from 'antd'
import { useParams, useNavigate } from 'react-router-dom'
import { relayStore } from '../../store/relay'
import { Record } from '../../helpers/types/relay'
import {
	RNCreateRelayOneRecord,
	RNRelay,
	RNRelayOneRecords,
	RNRelayType
} from '../../helpers/routeNames'
import { CharacteristicCard } from '../../components/CharacteristicCard'
import { PageBreadcrumb } from '../../components/PageBreadcrumb'

const { Title } = Typography

export const RelayRecords: FC = () => {
	const { relayId, relayOneId, relayTypeId } = useParams<{
		relayTypeId: string
		relayId: string
		relayOneId: string
	}>()
	const { relayTypes, fetchRelayOneRecords } = relayStore()
	const navigate = useNavigate()

	const [relayOneRecords, setRelayOneRecords] = useState<Record[]>(
		[]
	)

	const [page] = useState(1)

	useEffect(() => {
		if (!relayTypeId || !relayId || !relayOneId) return
		const fetch = async () => {
			const data = await fetchRelayOneRecords(
				relayTypeId,
				relayId,
				relayOneId,
				page
			)
			setRelayOneRecords(data)
		}
		fetch()
	}, [
		relayTypeId,
		relayId,
		relayOneId,
		fetchRelayOneRecords,
		page,
		relayTypes
	])

	const relayType = relayTypes.find((rt) =>
		rt.relays.some((r) => r.id === relayId)
	)
	const relay = relayType?.relays.find((r) => r.id === relayId)

	if (!relay) {
		return <div>Реле не найдено</div>
	}

	return (
		<div>
			<PageBreadcrumb
				items={[
					{ label: 'Типы реле', path: RNRelayType },
					{ label: relayType?.name || 'Тип реле', path: RNRelayType + '/' + relayTypeId },
					{ label: relay.name, path: RNRelay + '/' + relayId },
					{ label: 'Записи' }
				]}
			/>
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<Title level={2}>{relay.name}</Title>
			</header>
			<main>
				<CharacteristicCard
					title="Информация о реле"
					data={[
						{
							label: 'Срок службы',
							value: relay.expiration
						},
						{
							label: 'Дата создания',
							value: new Date(
								relay.createdAt
							).toLocaleString()
						}
					]}
				/>
				<Flex justify="space-between" align="center">
					<Title level={3}>Запись</Title>
					<Button
						type="primary"
						onClick={() => {
							navigate(
								RNCreateRelayOneRecord +
									'/' +
									relayTypeId +
									'/' +
									relayId +
									'/' +
									relayOneId
							)
						}}>
						Добавить запись
					</Button>
				</Flex>
				<List
					grid={{
						gutter: 16,
						column: 4,
						xs: 1,
						sm: 2,
						md: 3
					}}
					dataSource={relayOneRecords}
					renderItem={(relayOneRecord) => (
						<List.Item
							key={relayOneRecord.id}
							onClick={() => {
								navigate(
									RNRelayOneRecords +
										'/' +
										relayTypeId +
										'/' +
										relayId +
										'/' +
										relayOneId +
										'/' +
										relayOneRecord.id
								)
							}}>
							<Card
								title={`Уникальный номер реле: ${relay.name}`}
								onClick={() => {}}
								hoverable>
								<Descriptions
									size="small"
									column={1}
									items={[
										{
											label: 'Создано',
											children: new Date(
												relayOneRecord.createdAt ||
													0
											).toLocaleString('ru')
										}
									]}
								/>
							</Card>
						</List.Item>
					)}
				/>
			</main>
		</div>
	)
}
